import styles from './Segmented.module.css'

/**
 * Reusable segmented control.
 * @param {{key:string,label:string}[]} options
 * @param {string} value
 * @param {(key:string)=>void} onChange
 */
export default function Segmented({ options, value, onChange, ariaLabel }) {
  return (
    <div className={styles.seg} role="tablist" aria-label={ariaLabel}>
      {options.map((opt) => {
        const active = opt.key === value
        return (
          <button
            key={opt.key}
            type="button"
            role="tab"
            aria-selected={active}
            className={`${styles.btn} ${active ? styles.active : ''}`}
            onClick={() => onChange(opt.key)}
          >
            {opt.label}
            {opt.count != null && (
              <span className={styles.count}>{opt.count}</span>
            )}
          </button>
        )
      })}
    </div>
  )
}
